import {useUser} from "~/context/UserContext";
import {usePostHog} from "~/context/PostHogContext";
import {createEffect, JSXElement} from "solid-js";

export default function PostHogIdentify(): JSXElement | undefined {
    const user = useUser();
    const posthog = usePostHog();

    createEffect(() => {
        if (user.latest && user.latest.id) {
            posthog.identify(user.latest.id, {
                email: user.latest.email,
                name: user.latest.first_name + " " + user.latest.last_name,

            });
        }
    });

    return null;
}